<template>
	<div class="devtools-container">
		<h2>Developer Tools</h2>
		<p>Welcome to the DevTools interface. This area is restricted to authorized developers only.</p>

		<div class="tool-buttons">
			<button @click="analyzeS3Images" class="tool-button">S3</button>
			<button @click="inspectDatabase" class="tool-button">Inspect</button>
			<button @click="runDiagnostics" class="tool-button">Diagnostics</button>
		</div>

		<div v-if="error" class="error-message">
			{{ error }}
		</div>

		<div v-if="results" class="results-panel">
			<h3>Results</h3>
			<pre>{{ results }}</pre>
			<button v-if="s3Only && s3Only.length > 0" @click="createMissingNeo4jEntries" class="tool-button" style="margin-top: 10px;">
				Create Neo4j Entries for {{ s3Only.length }} Missing Items
			</button>
		</div>
	</div>
</template>

<script>
// import CreateImageMutation from '../graphql/server/Image/CreateImageMutation.gql';

export default {
	name: 'DevTools',
	data() {
		return {
			error: null,
			results: null,
			allowedUserID: '0000019f-1b05-767a-8a2d-d37cdebf3080',
			s3Only: []
		}
	},
	props: {
		authStatus: {
			type: Object,
			required: true
		}
	},
	methods: {
		// checkAccess() {
		// 	if (!this.authStatus?.isAuthenticated) {
		// 		this.error = 'Access denied: Please log in to use DevTools.';
		// 		return false;
		// 	}

		// 	if (this.authStatus.userID !== this.allowedUserID) {
		// 		this.error = 'Access denied: This tool is restricted to authorized developers only.';
		// 		return false;
		// 	}
		// 	return true;
		// },

        // async analyzeS3Images() {
        //     if (!this.checkAccess()) return;

        //     this.error = null;
        //     this.results = '🔄 Starting S3 synchronization to fix ID mismatches...\nThis may take a few moments depending on the number of objects.';

        //     try {
        //         const token = localStorage.getItem('user-token') || sessionStorage.getItem('user-token');
        //         if (!token) {
        //             this.error = 'Not authenticated';
        //             return;
        //         }

        //         // Use the unified endpoint that handles synchronization
        //         const baseUrl = process.env.VUE_APP_GRAPHQL_URL.replace('/graphql', '');

        //         const response = await fetch(baseUrl + "/api/analyze-and-sync-images", {
        //             method: 'POST',
        //             headers: {
        //                 'Content-Type': 'application/json',
        //                 'Authorization': "Bearer " + token
        //             }
        //         });

        //         if (!response.ok) {
        //             const errorText = await response.text();
        //             throw new Error("Server responded with status " + response.status + ": " + errorText);
        //         }

        //         const resultData = await response.json();

        //         if (!resultData.success) {
        //             throw new Error(resultData.error || 'Failed to synchronize S3 IDs');
        //         }

        //         // Process the results
        //         const summary = resultData.summary;
        //         const results = resultData.results;

        //         // Format the results for display
        //         let formattedResults = `🎉 S3 Synchronization Complete!\n\n`;

        //         formattedResults += `📊 Synchronization Summary:\n`;
        //         formattedResults += `- Total S3 Objects Processed: ${summary.totalObjects}\n`;
        //         formattedResults += `- S3 Keys Updated: ${summary.s3KeysUpdated}\n`;
        //         formattedResults += `- Already Synchronized: ${summary.alreadySynchronized}\n`;
        //         formattedResults += `- Needs Neo4j Entries: ${summary.needsNeo4jEntries}\n`;
        //         formattedResults += `- Skipped: ${summary.skipped}\n`;
        //         formattedResults += `- Errors: ${summary.errors}\n\n`;

        //         // Show S3 Keys that were updated (the main feature)
        //         const updatedResults = results.filter(r => r.status === "s3_key_updated");
        //         if (updatedResults.length > 0) {
        //             formattedResults += `🟡 S3 Keys Updated (${updatedResults.length}):\n`;
        //             updatedResults.forEach(result => {
        //                 formattedResults += `  🔧 ${result.oldS3Key} → ${result.newS3Key}\n`;
        //                 if (result.fileName) {
        //                     formattedResults += `     (Original: ${result.fileName})\n`;
        //                 }
        //             });
        //             formattedResults += '\n';
        //         }

        //         // Show other categories
        //         const needsEntriesResults = results.filter(r => r.status === "needs_neo4j_entry");
        //         if (needsEntriesResults.length > 0) {
        //             formattedResults += `🔴 Needs Neo4j Entries (${needsEntriesResults.length}):\n`;
        //             needsEntriesResults.forEach(result => {
        //                 formattedResults += `  ➕ ${result.s3Key}\n`;
        //             });
        //             formattedResults += '\n';
        //         }

        //         // Success message
        //         if (summary.s3KeysUpdated > 0) {
        //             formattedResults += `✅ SUCCESS: ${summary.s3KeysUpdated} S3 object(s) were updated to match Neo4j IDs!\n`;
        //             formattedResults += `   The ID mismatch issue has been fixed.\n`;
        //         } else {
        //             formattedResults += `✅ All S3 objects are already properly synchronized with Neo4j!\n`;
        //         }

        //         // Update the s3Only array for the "Create Missing Entries" button
        //         this.s3Only = needsEntriesResults.map(r => r.s3Key);

        //         this.results = formattedResults;

        //     } catch (error) {
        //         console.error('Error synchronizing S3 IDs:', error);
        //         this.error = "Error: " + error.message;

        //         this.results = "S3 synchronization failed. Please check:\n1. S3 credentials and bucket access\n2. Neo4j database connection\n3. Network connectivity\n4. S3 object metadata availability\n\nError details: " + error.message;
        //     }
		// },

		// async synchronizeS3Ids() {
		// 	if (!this.checkAccess()) return;

		// 	this.error = null;
		// 	this.results = '🔄 Starting S3 ID synchronization process...\nThis may take a few moments depending on the number of objects.';

		// 	try {
		// 		const token = localStorage.getItem('user-token') || sessionStorage.getItem('user-token');
		// 		if (!token) {
		// 			this.error = 'Not authenticated';
		// 			return;
		// 		}

		// 		const baseUrl = process.env.VUE_APP_GRAPHQL_URL.replace('/graphql', '');

		// 		// Call the S3 ID synchronization endpoint
		// 		const response = await fetch(baseUrl + "/api/s3-sync-ids", {
		// 			method: 'POST',
		// 			headers: {
		// 				'Content-Type': 'application/json',
		// 				'Authorization': "Bearer " + token
		// 			}
		// 		});

		// 		if (!response.ok) {
		// 			const errorText = await response.text();
		// 			throw new Error("Server responded with status " + response.status + ": " + errorText);
		// 		}

		// 		const resultData = await response.json();

		// 		if (!resultData.success) {
		// 			throw new Error(resultData.error || 'Failed to synchronize S3 IDs');
		// 		}

		// 		// Format the results for display
		// 		const summary = `🎉 S3 ID Synchronization Complete!\n\n` +
		// 			`📊 Total S3 Objects Analyzed: ${resultData.totalObjects}\n` +
		// 			`🔄 Changes Made: ${resultData.changesMade}\n` +
		// 			`✅ Status: ${resultData.message}\n\n`;

		// 		if (resultData.results && resultData.results.length > 0) {
		// 			const successChanges = resultData.results.filter(r => r.status === 'success');
		// 			const errorChanges = resultData.results.filter(r => r.status === 'error');

		// 			let details = '';

		// 			if (successChanges.length > 0) {
		// 				details += `🟢 Successfully Synchronized (${successChanges.length}):\n`;
		// 				successChanges.forEach(change => {
		// 					details += `  ✅ ${change.oldKey} → ${change.newKey} (${change.fileName})\n`;
		// 				});
		// 				details += '\n';
		// 			}

		// 			if (errorChanges.length > 0) {
		// 				details += `❌ Failed to Synchronize (${errorChanges.length}):\n`;
		// 				errorChanges.forEach(change => {
		// 					details += `  ❌ ${change.key}: ${change.error}\n`;
		// 				});
		// 				details += '\n';
		// 			}

		// 			this.results = summary + details;
		// 		} else {
		// 			this.results = summary + "✅ No changes were needed - all S3 objects are already synchronized with Neo4j IDs!";
		// 		}

		// 	} catch (error) {
		// 		console.error('Error synchronizing S3 IDs:', error);
		// 		this.error = "Error: " + error.message;

		// 		this.results = "S3 ID synchronization failed. Please check:\n1. S3 credentials and bucket access\n2. Neo4j database connection\n3. Network connectivity\n4. Metadata availability for S3 objects\n\nError details: " + error.message;
		// 	}
		// },

		// runDiagnostics() {
		// 	if (!this.checkAccess()) return;

		// 	this.error = null;
		// 	this.results = 'Running system diagnostics...\nThis would check system health and performance metrics.';
		// 	// TODO: Implement actual database inspection logic
		// },

		// async createMissingNeo4jEntries() {
		// 	if (!this.checkAccess()) return;

		// 	this.error = null;
		// 	this.results = 'Creating Neo4j entries for missing S3 items...';

		// 	try {
		// 		const token = localStorage.getItem('user-token') || sessionStorage.getItem('user-token');
		// 		if (!token) {
		// 			this.error = 'Not authenticated';
		// 			return;
		// 		}

		// 		// Re-run the analysis to get fresh data
		// 		await this.analyzeS3Images();

		// 		// Extract the S3-only items (red items) from the results
		// 		// We need to re-run the same logic to get the s3Only array
		// 		const baseUrl = process.env.VUE_APP_GRAPHQL_URL.replace('/graphql', '');
		// 		const s3Response = await fetch(baseUrl + "/api/s3-list", {
		// 			headers: {
		// 				'Authorization': "Bearer " + token
		// 			}
		// 		});

		// 		if (!s3Response.ok) {
		// 			const errorText = await s3Response.text();
		// 			throw new Error("Server responded with status " + s3Response.status + ": " + errorText);
		// 		}

		// 		const s3Data = await s3Response.json();
		// 		if (!s3Data.success) {
		// 			this.error = s3Data.error || 'Failed to list S3 objects';
		// 			return;
		// 		}

		// 		const s3Objects = s3Data.objects;

		// 		// Get metadata for the objects
		// 		const metadataResponse = await fetch(baseUrl + "/api/s3-metadata", {
		// 			method: 'POST',
		// 			headers: {
		// 				'Content-Type': 'application/json',
		// 				'Authorization': "Bearer " + token
		// 			},
		// 			body: JSON.stringify({
		// 				keys: s3Objects
		// 			})
		// 		});

		// 		let s3Metadata = [];
		// 		if (metadataResponse.ok) {
		// 			const metadataData = await metadataResponse.json();
		// 			if (metadataData.success && metadataData.metadata) {
		// 				s3Metadata = metadataData.metadata;
		// 			}
		// 		}

		// 		// Query Neo4j for existing image hashes
		// 		const s3Hashes = s3Objects.map(obj => {
		// 			const lastDotIndex = obj.lastIndexOf('.');
		// 			return lastDotIndex > 0 ? obj.substring(0, lastDotIndex) : obj;
		// 		});

		// 		const neo4jResponse = await fetch(baseUrl + "/graphql", {
		// 			method: 'POST',
		// 			headers: {
		// 				'Content-Type': 'application/json',
		// 				'Authorization': "Bearer " + token
		// 			},
		// 			body: JSON.stringify({
		// 				query: "query CheckImages($fileHashes: [String!]!, $userID: String!) { CheckImages(fileHashes: $fileHashes, userID: $userID) }",
		// 				variables: {
		// 					fileHashes: s3Hashes,
		// 					userID: this.authStatus.userID
		// 				}
		// 			})
		// 		});

		// 		if (!neo4jResponse.ok) {
		// 			const errorText = await neo4jResponse.text();
		// 			throw new Error("Neo4j query failed with status " + neo4jResponse.status + ": " + errorText);
		// 		}

		// 		const neo4jData = await neo4jResponse.json();
		// 		if (neo4jData.errors) {
		// 			throw new Error("Neo4j error: " + neo4jData.errors[0].message);
		// 		}

		// 		const existingHashes = neo4jData.data.CheckImages || [];

		// 		// Create neo4jImages array
		// 		const neo4jImages = existingHashes.map(hash => {
		// 			const s3Obj = s3Objects.find(obj => obj.startsWith(hash + '.'));
		// 			const extension = s3Obj ? s3Obj.substring(hash.length + 1) : '';
		// 			return {
		// 				hash: hash,
		// 				extension: extension,
		// 				originalName: hash + (extension ? '.' + extension : '')
		// 			};
		// 		});

		// 		// Find S3 objects not in Neo4j (these are the ones we want to create)
		// 		this.s3Only = [];

		// 		s3Objects.forEach(obj => {
		// 			const isMatched = neo4jImages.some(img => img.hash === obj);
		// 			if (!isMatched) {
		// 				this.s3Only.push(obj);
		// 			}
		// 		});

		// 		if (this.s3Only.length === 0) {
		// 			this.results = "✅ No missing items found. All S3 objects are already in Neo4j.";
		// 			return;
		// 		}

		// 		// Create Neo4j entries for each missing item
		// 		let successCount = 0;
		// 		let errorCount = 0;
		// 		let duplicateCount = 0;

		// 		for (const objKey of this.s3Only) {
		// 			try {
		// 				const metadata = s3Metadata.find(m => m.key === objKey) || {};
		// 				const hashPart = objKey.split('.')[0];
		// 				const extension = objKey.split('.').pop() || '';

		// 				// Create file metadata similar to ImagesView.vue
		// 				const fileMetadata = {
		// 					ID: hashPart,
		// 					key: objKey,
		// 					fileName: objKey,
		// 					dateTaken: metadata.lastModified ? new Date(metadata.lastModified).toISOString() : new Date().toISOString(),
		// 					dateCreated: new Date().toISOString(),
		// 					createdBy: this.authStatus.userID,
		// 					ownerIdentityId: this.authStatus.userID,
		// 					fileType: extension,
		// 					size: metadata.size ? metadata.size.toString() : '0',
		// 					latitude: null,
		// 					longitude: null
		// 				};

		// 				// Use the same CreateImageMutation as ImagesView.vue
		// 				const childNods = {
		// 					ID: fileMetadata.ID,
		// 					key: fileMetadata.key,
		// 					fileName: fileMetadata.fileName,
		// 					dateTaken: fileMetadata.dateTaken,
		// 					dateCreated: fileMetadata.dateCreated,
		// 					createdBy: fileMetadata.createdBy,
		// 					ownerIdentityId: fileMetadata.ownerIdentityId,
		// 					fileType: fileMetadata.fileType,
		// 					fileSize: fileMetadata.size,
		// 					latitude: fileMetadata.latitude,
		// 					longitude: fileMetadata.longitude
		// 				};

        //                 // Call the GraphQL mutation
        //                 await this.$apollo.mutate({
        //                     mutation: CreateImageMutation,
        //                     variables: {childNods}
        //                 });

        //                 successCount++;
        //                 console.log(`✅ Created Neo4j entry for: ${objKey}`);

		// 			} catch (error) {
		// 				errorCount++;
		// 				console.error(`Failed to create Neo4j entry for ${objKey}:`, error);

		// 				// Handle duplicate errors
		// 				const duplicate = error?.graphQLErrors?.find(e => e?.extensions?.code === 'IMAGE_KEY_EXISTS');
		// 				if (duplicate) {
		// 					duplicateCount++;
		// 					console.log(`⚠️  Skipping duplicate: ${objKey}`);
		// 				} else if (error.graphQLErrors && error.graphQLErrors.length > 0) {
		// 					console.error('GraphQL errors:', error.graphQLErrors);
		// 				} else {
		// 					console.error('Unknown error:', error.message);
		// 				}
		// 			}
		// 		}

		// 		// Run analysis again to update the display
		// 		await this.analyzeS3Images();

		// 		this.results = `🎉 Neo4j Entry Creation Complete!\n\n` +
		// 			`✅ Successfully created ${successCount} Neo4j entries\n` +
		// 			`⚠️  Skipped ${duplicateCount} duplicates\n` +
		// 			`❌ Failed to create ${errorCount} entries due to errors\n\n` +
		// 			`The analysis has been re-run to show the updated status.`;

		// 	} catch (error) {
		// 		console.error('Error creating Neo4j entries:', error);
		// 		this.error = "Error creating Neo4j entries: " + error.message;
		// 		this.results = "Analysis failed during Neo4j entry creation. Please check logs for details.";
		// 	}
		// }
	},
	mounted() {
		// Check access when component mounts
		this.checkAccess();
	}
}
</script>

<style scoped>
.devtools-container {
	max-width: 1200px;
	margin: 20px auto;
	padding: 20px;
	background: white;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.devtools-container h2 {
	color: #2c3e50;
	border-bottom: 2px solid #a6f4e5;
	padding-bottom: 10px;
}

.tool-buttons {
	display: flex;
	gap: 10px;
	margin: 20px 0;
	flex-wrap: wrap;
}

.tool-button {
	background-color: #a6f4e5;
	color: #2c3e50;
	border: none;
	padding: 8px 16px;
	border-radius: 4px;
	cursor: pointer;
	font-size: 14px;
	font-weight: 500;
	transition: background-color 0.2s;
}

.tool-button:hover {
	background-color: #8edbc8;
}

.error-message {
	color: #dc3545;
	background: #f8d7da;
	padding: 10px;
	border-radius: 4px;
	margin-top: 15px;
	border: 1px solid #f5c6cb;
}

.results-panel {
	background: #e9ecef;
	padding: 15px;
	border-radius: 6px;
	margin-top: 20px;
	max-height: 300px;
	overflow-y: auto;
}

.results-panel h3 {
	color: #495057;
	margin-top: 0;
	font-size: 16px;
}

.results-panel pre {
	white-space: pre-wrap;
	font-family: 'Courier New', monospace;
	font-size: 13px;
	margin: 0;
}
</style>